require('./insuranceRequestWizardGDPRMessage.override.scss');

// @ vendor
const React = require('react');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

const buildCCMandatoryGdprReading = () => {
    const poeditorPrefix = 'insuranceRequestHomeCC';
    const message = `${poeditorPrefix}-${poeditorPrefix}_GDPRMessageStep4`;
    const linkUrl = formatText(`${poeditorPrefix}-${poeditorPrefix}_GDPRMessageLinkUrlStep4`);
    const linkText = `${poeditorPrefix}-${poeditorPrefix}_GDPRMessageLinkTextStep4`;

    return (
        <BlockInfo
            extraClass={'insurance-request-wizard-gdpr-message__block-info'}
        >
            <FormattedText value={message} />
            <OKLink
                modifier="emphasize"
                target="_blank"
                to={linkUrl}
            >
                <FormattedText value={linkText} />
            </OKLink>
        </BlockInfo>
    );
}

const buildGdprReading = () => {
    return (
        <OKMessage
            title={formatText("insuranceRequestHome-step4InsurancesGDPRTitle")}
            type="informative"
        >
            <FormattedText value="disclaimerPersonalInfo-insuranceRequestHomeMsg" />
            <OKLink
                modifier="emphasize"
                target="_blank"
                to={formatText("disclaimerPersonalInfo-insuranceRequestHomeLinkUrl")}
            >
                <FormattedText value="disclaimerPersonalInfo-insuranceRequestHomeLinkText" />
            </OKLink>
        </OKMessage>
    );
}

const InsuranceRequestWizardGDPRMessage = () => (
    __CONTACT_CENTER__ ? buildCCMandatoryGdprReading() : buildGdprReading()
);

module.exports = InsuranceRequestWizardGDPRMessage;
